<template>
  <div id="market-account-index-root">
    <div class="col-xl-10 mx-auto">
      <div class="card">
        <div class="card-body pt-3">
          <b-col>
            <b-row>
              <h3>Marktplatz Accounts</h3>
            </b-row>
            <b-row>
              <b-table
                :items="marketAccounts"
                :fields="fields"
                striped
                hover
                small
              >
                <!-- :tbody-tr-class="rowClass" -->
                <template v-slot:cell(name)="row" class="col-3">
                  <span class="link" @click="edit(row.item.id)">{{
                    row.item.name
                  }}</span>
                </template>
                <template v-slot:cell(actions)="row" class="col-3">
                  <b-button-group class="float-right">
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="openShippingSeriveEditor(row.item)"
                    >
                      <span class="icon icon-gift"></span>
                    </b-button>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="edit(row.item.id)"
                    >
                      <span class="icon icon-pencil"></span>
                    </b-button>
                  </b-button-group>
                </template>
              </b-table>
            </b-row>
          </b-col>
        </div>
      </div>
    </div>
    <market-account-edit-component
      :mutantId="marketAccountId"
      :marketAccounts="marketAccounts"
      @closed="marketAccountId = null"
    ></market-account-edit-component>
    <market-account-shipping-service-component
      :marketAccount="marketAccount"
      @closed="marketAccount = null"
    ></market-account-shipping-service-component>
  </div>
</template>
<style>
.link:hover {
  color: rgb(52, 144, 220);
  cursor: pointer;
}
</style>
<script>
import MarketAccountShippingServiceComponent from "./MarketAccountShippingServiceComponent.vue";
export default {
  components: { MarketAccountShippingServiceComponent },
  data() {
    return {
      marketAccounts: null,
      marketAccountId: null, // which is passed to edit component
      marketAccount: null, // which is passed to the shipping_service edit component
      fields: [
        { key: "id", label: "ID", sortable: true },
        { key: "name", label: "Name", sortable: true },
        { key: "description", label: "Beschreibung", sortable: true },
        { key: "actions", label: "", sortable: false },
      ],
    };
  },
  methods: {
    edit(marketAccountId) {
      if (null !== this.marketAccountId) {
        this.$bvToast.toast(
          "Ein MarketAccount Wird bereits bearbeitet. Falls nicht, bitte melden.",
          {
            title: "Market Account Index",
            autoHideDelay: 32000,
            appendToast: false,
            variant: "danger",
          },
        );
        return;
      }
      this.marketAccountId = marketAccountId;
    },
    openShippingSeriveEditor(marketAccount) {
      this.marketAccount = marketAccount;
    },
  },
  created() {
    axios
      .get("/marketaccount/all_with_shipping_services")
      .then((response) => {
        this.marketAccounts = response.data;
      })
      .catch((error) => {
        this.$bvToast.toast("Daten konnten nicht runtergeladen werden.", {
          title: "MarketAccount Index",
          autoHideDelay: 32000,
          appendToast: false,
          variant: "danger",
        });
        console.error(error);
      });
  },
};
</script>
